import Carousel from "react-bootstrap/Carousel";
import { useState } from "react";

function PreparingSignUpCarosel(props) {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  return (
    <div className="feature-cards-container">
      <div className="feature-card-heading mb-1">Do you know ?</div>
      <div className="mt-2 mb-3">
        <Carousel activeIndex={index} onSelect={handleSelect} interval={3500}>
          {props.data.map((card, key) => {
            return (
              <Carousel.Item key={key} id={key}>
                <div className="feature-card-description text-align-left w-100 d-block">
                  {card}
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
}

export default PreparingSignUpCarosel;
